import React, {FC} from 'react';
import styled from 'styled-components';

import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {BoxedInput} from '../../../../../libs/shared/ui/src/components/boxedInputs/boxedInput';
import {BoxedInputElement} from '../../../../../libs/shared/ui/src/components/boxedInputs/boxedInputElement';
import {BoxedTextAreaElement} from '../../../../../libs/shared/ui/src/components/boxedInputs/boxedTextAreaElement';
import {InputTypesEnum} from '../../../../../libs/shared/ui/src/components/inputs/input';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {StringParameter} from '../../../editors/commons/parameterModel';

/*
 * Types.
 */

interface Props {
  stringParameter: StringParameter;
  value: string | undefined;
  isDisabled?: boolean;
  onValueChange: HandlerOf<string>;
}

/*
 * Styles.
 */

// Prevent 0-width input in some cases (e.g first line of a RuleParameterCard).
const StyledInputWrapper = styled.div`
  flex-grow: 1;
`;

const StyleTextareaWrapper = styled.div`
  flex-grow: 1;

  textarea {
    height: 68px;
  }
`;

const StyledBoxedTextAreaElement = styled(BoxedTextAreaElement)`
  overflow-y: auto;
`;

/*
 * Component.
 */

export const InputStringParameter: FC<Props> = (props) => {
  const {stringParameter, value, onValueChange} = props;
  const placeholder = stringParameter.description || stringParameter.title;

  if (stringParameter.multiline) {
    return (
      <StyleTextareaWrapper>
        <BoxedInput noMargin>
          {(childProps) => (
            <StyledBoxedTextAreaElement
              {...childProps}
              value={value ?? ''}
              onChange={onValueChange}
              placeholder={placeholder}
              size={VisualSizesEnum.MEDIUM}
              isDisabled={props.isDisabled}
            />
          )}
        </BoxedInput>
      </StyleTextareaWrapper>
    );
  }

  return (
    <StyledInputWrapper>
      <BoxedInput noMargin>
        {(childProps) => (
          <BoxedInputElement
            {...childProps}
            value={value ?? ''}
            onChange={onValueChange}
            placeholder={placeholder}
            type={InputTypesEnum.TEXT}
            size={VisualSizesEnum.MEDIUM}
            isDisabled={props.isDisabled}
          />
        )}
      </BoxedInput>
    </StyledInputWrapper>
  );
};
